import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { PermissionSetting } from 'types';

export const getUserPermissionSettings =
  async (): Promise<PermissionSetting> => {
    const { data } = await axios.get(`/api/users/settings`);
    return data as PermissionSetting;
  };

type QueryFnType = typeof getUserPermissionSettings;

type UseUserPermissionSettingsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useUserPermissionSettings = ({
  config,
}: UseUserPermissionSettingsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['users', 'permissionSettings'],
    queryFn: getUserPermissionSettings,
    ...config,
  });
};
